import { Dispatch, SetStateAction } from "react";
import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { GalleryObject, VideoPreloadValue } from "../../utils";
import styles from "./ZoomModal.module.scss";
import { Carousel } from "../Carousel/Carousel";
import { LineIndicator } from "../LineIndicator/LineIndicator";
import { Counter } from "../../CarouselGallery/CarouselGalleryUI";
import { dispatchGalleryMonetateQEvent } from "../Analytics/dispatchGalleryMonetateQEvent";

export interface ZoomModalProps {
  closeZoomModal: () => void;
  mediaItems: GalleryObject[];
  setSelectedIndex: Dispatch<SetStateAction<number>>;
  selectedIndex: number;
  hasImmediateStateUpdates?: boolean;
  hasDeferredMonetateQEvents?: boolean;
  hasDeferredIntersectionObserverCallback?: boolean;
  hasSuperZoom?: boolean;
  carouselGalleryInpTest?: boolean;
  videoPreload: VideoPreloadValue;
  videoAutoplayOnLoad?: boolean;
}
export const ZoomModal = ({
  closeZoomModal,
  mediaItems,
  setSelectedIndex,
  selectedIndex,
  hasImmediateStateUpdates,
  hasDeferredMonetateQEvents,
  hasDeferredIntersectionObserverCallback,
  hasSuperZoom,
  carouselGalleryInpTest = false,
  videoPreload,
  videoAutoplayOnLoad = false,
}: ZoomModalProps) => {
  const handleCloseZoomModal = () => {
    const mode = mediaItems[0]?.type === "video" ? "video" : "image";
    dispatchGalleryMonetateQEvent(
      "CloseModal",
      `${mode}Modal`,
      undefined,
      carouselGalleryInpTest,
    );
    closeZoomModal();
  };

  return (
    <Modal
      isOpen
      height="fixed"
      headerType="empty"
      variant="full-screen"
      footer={false}
      width="extra-large"
      onClose={handleCloseZoomModal}
      className={styles.galleryContainer}
    >
      <Carousel
        fullscreen
        mediaItems={mediaItems}
        selectedInd={selectedIndex}
        setSelectedInd={setSelectedIndex}
        hasImmediateStateUpdates={hasImmediateStateUpdates}
        hasDeferredMonetateQEvents={hasDeferredMonetateQEvents}
        hasDeferredIntersectionObserverCallback={
          hasDeferredIntersectionObserverCallback
        }
        hasSuperZoom={hasSuperZoom}
        carouselGalleryInpTest={carouselGalleryInpTest}
        videoPreload={videoPreload}
        videoAutoplayOnLoad={videoAutoplayOnLoad}
      >
        {mediaItems.length > 1 && (
          <div className={styles.lineIndicator}>
            <LineIndicator
              currentIndex={selectedIndex}
              numberOfImages={mediaItems.length}
            />
            <Counter
              fullscreen
              selectedInd={selectedIndex}
              itemCount={mediaItems.length}
            />
          </div>
        )}
      </Carousel>
    </Modal>
  );
};
